import { useShows } from "@/context/ShowContext";

export function PricingLimitedBanner() {
  const { selectedShow } = useShows();
  if (!selectedShow?.pricing_limited) return null;

  return (
    <div
      className="rounded-sm px-4 py-2.5 text-[11px] leading-relaxed"
      style={{
        background: "rgba(234,172,85,0.08)",
        border: "1px solid rgba(234,172,85,0.18)",
        color: "#b8a07a",
      }}
    >
      <span className="font-semibold" style={{ color: "#d4b068" }}>Estimated pricing</span>
      {" — "}
      {selectedShow.festival_name || "This festival"} does not provide artists with $ value of tickets sold. Revenue figures shown are approximated from your listing's published ticket prices to give you timely feedback on audience growth.
    </div>
  );
}

export function PricingLimitedFooter() {
  const { selectedShow } = useShows();
  if (!selectedShow?.pricing_limited) return null;

  return (
    <div className="px-4 py-1.5 text-center" style={{ background: "rgba(234,172,85,0.05)", borderTop: "1px solid rgba(234,172,85,0.12)" }}>
      <span className="text-[10px]" style={{ color: "#9a8a6a" }}>
        {selectedShow.festival_name || "This festival"} does not provide artists with $ value of tickets sold. Revenue figures for this show are estimated from published ticket prices. Actual settlement values may differ.
      </span>
    </div>
  );
}
